import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ApiContext } from '../context/Api';
import {useQuery} from "@tanstack/react-query";

function CourseModel() {
  const { apiService } = useContext(ApiContext);
  const { lang, courseSlug } = useParams();

  const {
    data,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['getCourse', lang, courseSlug],
    queryFn: async () => {
      const response = await apiService.getCourse(lang, courseSlug);
      if (!response || !response.data || !response.data.courses) {
        throw new Error('Invalid response');
      }
      return response.data.courses[0];
    },
    enabled: !!lang,
  });

  return {
    course: data,
    isLoading,
    isError,
    refetch,
  };
}
export default CourseModel;
